import { z } from 'zod';
import { baseOutputMetadataSchema } from '../outputMetadata';
export const MCP_TOOL_LIST_EXPLORES_DESCRIPTION = ({ toolName, }) => `Tool: ${toolName}

List the explores the user can access in a project, limited to the agent's tags when agent-scoped: each explore's name, label, base table, tags, joined tables and required filters, without its fields. Use it for an overview of the available data; grep_fields and get_metadata give the fields.
`;
// MCP-only tool - no type field needed
export const mcpToolListExploresArgsSchema = z.object({});
export const mcpToolListExploresOutputSchema = z.object({
    result: z.string(),
    metadata: baseOutputMetadataSchema,
});
//# sourceMappingURL=mcpToolListExploresArgs.js.map